import { Grid, TableCell, Typography, withStyles } from "@material-ui/core";
import React from "react";
import {
  COLUMNS_WITHOUT_PORTAL_DATA,
  getStylesForDifferenceSummaryColumnCell,
  PAGE_TYPE,
  TABLE_COLUMNS,
} from "../conciliacaoUtil";

export const ConciliationSummaryTableRowCell = ({
  appValue,
  classes,
  columnId,
  pageType,
  portalValue,
}) => {
  const hidePortalValue = COLUMNS_WITHOUT_PORTAL_DATA.includes(columnId);
  const shouldGetAbsAppValue =
    COLUMNS_WITHOUT_PORTAL_DATA.includes(columnId) &&
    typeof appValue === "number";

  const cellClassesMap = {
    [TABLE_COLUMNS.ORIGIN]: classes.bottomLeftCell,
    [TABLE_COLUMNS.DIFFERENCE]: classes.bottomRightCell,
  };

  const contentClassMap = {
    [PAGE_TYPE.DEFAULT]: classes.contentForPage,
    [PAGE_TYPE.PRINT]: classes.contentForPrint,
  };

  const cellClass = cellClassesMap[columnId] || classes.defaultCell;
  const contentClass = contentClassMap[pageType];

  return (
    <TableCell
      align="center"
      className={cellClass}
      component="th"
      padding="none"
      scope="row"
    >
      <Grid container direction="row" style={{ justifyContent: "center" }}>
        <div>
          <CellContent
            key={`cell-content-${columnId}-app`}
            className={contentClass}
            columnId={columnId}
            value={shouldGetAbsAppValue ? Math.abs(appValue) : appValue}
          />
          {!hidePortalValue && (
            <CellContent
              key={`cell-content-${columnId}-portal`}
              className={contentClass}
              columnId={columnId}
              value={portalValue}
            />
          )}
        </div>
      </Grid>
    </TableCell>
  );
};

const CellContent = ({ className, columnId, pageType, value }) => {
  const textStyle = getStylesForDifferenceSummaryColumnCell({
    columnId,
    pageType,
    value,
  });

  return (
    <Typography className={className} style={textStyle}>
      {value}
    </Typography>
  );
};

const styles = {
  typography: {
    fontFamily: "Roboto",
  },
  defaultCell: {
    height: "96px",
    border: "solid 1px #e5e5ea",
    maxWidth: "156px",
  },
  bottomLeftCell: {
    height: "96px",
    borderRadius: "0 0 0 16px",
    border: "none",
    maxWidth: "156px",
  },
  bottomRightCell: {
    height: "96px",
    borderRadius: "0 0 16px 0",
    border: "none",
    maxWidth: "156px",
  },
  contentForPage: {
    fontFamily: "Roboto",
    fontWeight: "normal",
    color: "#666666",
    fontSize: "21px",
  },
  contentForPrint: {
    fontFamily: "Roboto",
    fontWeight: "normal",
    color: "#666666",
    fontSize: "16px",
  },
};

export default withStyles(styles)(ConciliationSummaryTableRowCell);
